import { UPDATE_PROFILE } from "../actionTypes/profile";

const initialState = JSON.parse(localStorage.getItem("Profile")) || {};

export default function (state = initialState, action) {
  switch (action.type) {
    case UPDATE_PROFILE: {
      const { data } = action;
      saveToLocalStorage(data);
      return { ...state, ...data };
    }
    default:
      return state;
  }
}

const saveToLocalStorage = (data) => {
  localStorage.setItem("Profile", JSON.stringify(data));
};
